// extracted by mini-css-extract-plugin
export default {"textPanel":"TextToolbar_textPanel__tReQl"};